module.exports = __webpack_public_path__ + "static/dao-5903ae2bdb57d18203b6a5ac42a15cd7.jpg";